module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio37-c5078f75e723424b484bca0fe86ac950.m4a";